import axios from "axios";

import { ApiConfig } from "./ConstantService";
import { get_user_groups } from "./SessionTools";

export async function get_s3_signed_url(api_url, id_token, pathSetting) {
  let file_upload_url = api_url + "/v2/clientFileUpload"
  console.log("file_upload_url: ", file_upload_url);

  let body = JSON.stringify(pathSetting);
  console.log("body: ", body);

  return (await axios.post(file_upload_url, body, { headers: { Authorization: id_token } }))
    .data;
}

export async function upload_file_to_aws(signed_url, file_data, user) {
  try {
    let res = await axios.put(signed_url, file_data, {
      headers: { "x-amz-meta-username": user.profile.email },
    });
    return res.status;
  } catch (err) {
    console.error(err);
    return 401;
  }
}


export async function new_get_s3_signed_url(token, path_setting) {
  const graphqlEndpoint = "/graphql";
  const id_token = token["id_token"];

  const mutation = `
    mutation GenerateSignedUrl($input: GenerateSignedUrlInput!) {
      generateSignedUrl(input: $input) {
        url
        success
        statusCode
        errorMessage
        includeUsernameMetadata
        metadataUsername
        fileLogId
      }
    }
  `;

  const response = await axios.post(
    graphqlEndpoint,
    {
      query: mutation,
      variables: {
        input: {
          bucket: path_setting.bucket,
          pathPrefix: path_setting.pathPrefix,
          filename: path_setting.filename,
          jiraTicket: path_setting.jiraTicket,
        },
      },
    },
    { headers: { Authorization: `Bearer ${id_token}`, "Content-Type": "application/json" } }
  );

  if (response.status === 200 && response.data?.data?.generateSignedUrl) {
    return response.data.data.generateSignedUrl;
  }
  throw new Error("Invalid response from server");
}

export async function new_upload_file_to_aws(signed_url, file_data, metadataUsername, includeUsernameMetadata = true) {
  try {
    const headers = {};
    if (includeUsernameMetadata && metadataUsername) {
      headers["x-amz-meta-username"] = metadataUsername;
    }
    const res = await axios.put(signed_url, file_data, { headers });
    return res.status;
  } catch (err) {
    console.error(err);
    return 403;
  }
}

export async function update_file_log(token, fileLogId, status) {
  const graphqlEndpoint = "/graphql";
  const id_token = token["id_token"];

  const mutation = `
    mutation UpdateFileLog($fileLogId: String!, $frontendStatus: String!) {
      updateFileLog(input: { fileLogId: $fileLogId, frontendStatus: $frontendStatus })
    }
  `;

  try {
    await axios.post(
      graphqlEndpoint,
      { query: mutation, variables: { fileLogId, frontendStatus: status } },
      { headers: { Authorization: `Bearer ${id_token}` } }
    );
  } catch (err) {
    console.error("Failed to update file log:", err);
  }
}

export async function new_upload_file(token, path_setting, selectedFile) {
  path_setting["filename"] = selectedFile.name;

  try {
    const signed_url_res = await new_get_s3_signed_url(token, path_setting);
    const { url, success, statusCode, includeUsernameMetadata, metadataUsername, fileLogId } = signed_url_res;

    if (!success) {
      if (fileLogId) await update_file_log(token, fileLogId, "Failed");
      console.log("Failed to get signed URL, status:", statusCode);
      return false;
    }

    if (url) {
      const res = await new_upload_file_to_aws(url, selectedFile, metadataUsername, includeUsernameMetadata);
      if (res === 200) {
        if (fileLogId) await update_file_log(token, fileLogId, "AwaitingVerification");
        return true;
      } else {
        if (fileLogId) await update_file_log(token, fileLogId, "Failed");
        console.log("S3 upload failed, status:", res);
        return false;
      }
    }
  } catch (error) {
    console.error("Something went wrong with new_upload_file:", error);
  }
  return false;
}

export async function upload_file(
  file_upload_api_gateway_endpoint,
  selectedFileName,
  selectedFile,
  user
) {
  let user_groups = get_user_groups(user);
  let partner_group = user_groups.find((element) =>
    element.includes("csol-11931-users-group-")
  );
  let partnerid = "";

  if (partner_group != null) {
    partnerid = partner_group.replace("csol-11931-users-group-", "");
    let localPathSetting = {
      Region: "us-east-1",
      Filename: selectedFileName,
      User: user.profile.email,
      Bucket: ApiConfig.bucket,
      PathPrefix: partnerid,
    };

    get_s3_signed_url(file_upload_api_gateway_endpoint, user.id_token, localPathSetting)
      .then((signed_url_res) => {
        let signed_url = signed_url_res["URL"];
        let success = signed_url_res["Success"];
        if (success === false) {
          console.log(signed_url_res["StatusCode"]);
        }
        if (signed_url !== "")
          upload_file_to_aws(signed_url, selectedFile, user)
            .then((res) => {
              if (res === 200) {
                if (success === true) {
                  return true;
                } else {
                  console.log(res);
                  return false;
                }
              } else {
                console.log(res);
                return false;
              }
            })
            .catch(function (error_) {
              console.log("Something went wrong with uploading file");
              console.log(error_);
              return false;
            });
      })
      .catch(function (error) {
        console.log("Something went wrong with signed url");
        console.log(error);
        return false;
      });
  } else {
    console.log("PartnerId is null");
  }
  return false;
}

export async function post_camapign_data(
  file_upload_api_gateway_endpoint,
  campaign_data,
  user
) {
  let user_groups = get_user_groups(user);
  let partner_group = user_groups.find((element) =>
    element.includes("csol-11931-users-group-")
  );
  let partnerid = "";

  if (partner_group != null) {
    partnerid = partner_group.replace("csol-11931-users-group-", "");
    campaign_data["PartnerId"] = partnerid;
    let body = JSON.stringify(campaign_data);

  let post_response =  (await axios.post(file_upload_api_gateway_endpoint, body, { headers: { Authorization: user.id_token } }));
  console.log("post_response: ", post_response);
  return post_response.data;

  } else {
    console.log("PartnerId is null");
  }
  return {"Success": false, "Message": "Something went wrong"};
}